export function createSatMetodoPago() {
  return {
    EmpresaId: 0,
    CMetodoPago: '',
    Descripcion: '',
    EsActivo: true
  };
}
